/**
 * Generated runtime TestId mirror for frontend/src/components/attributes/DefinitionImpactConfirmDialog.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

export const DefinitionImpactConfirmDialogTestIds = {
  definitionImpactConfirmDialog: "definition-impact-confirm-dialog",
  impactConfirmButton: "impact-confirm-button",
  impactConfirmCancel: "impact-confirm-cancel",
  impactConfirmationCheckbox: "impact-confirmation-checkbox",
  saveWithMigrationButton: "save-with-migration-button"
} as const;
